import { useEffect } from 'react';
import { Button, Flex, Result } from 'antd';
import { useNavigate, useRouteError } from 'react-router-dom';
import { errorReporter } from '@/shared/lib/errorReporter';

/** `errorElement` at the router root — catches anything a route/loader throws that
 *  `ErrorBoundary` (a render-time-only React boundary) wouldn't. */
export function ErrorPage() {
  const navigate = useNavigate();
  const error = useRouteError();

  useEffect(() => {
    errorReporter.captureException(error);
  }, [error]);

  return (
    <Flex vertical align="center" justify="center" style={{ minHeight: '100vh', padding: 16 }}>
      <Result
        status="error"
        title="Произошла ошибка"
        extra={
          <Button type="primary" onClick={() => void navigate('/')}>
            На главную
          </Button>
        }
      />
    </Flex>
  );
}
